/**
 * Quotes Slider Block — Frontend Script.
 *
 * Initialises an Embla carousel for each quotes-slider block on the page.
 * Wires up prev/next buttons and a "current / total" counter.
 * Touch drag is enabled by default in Embla (no extra config needed).
 *
 * Embla loads deferred via CDN, so it may not be available at DOMContentLoaded.
 * A polling helper waits for window.EmblaCarousel before initialising.
 *
 * Controls are only present in the DOM when more than one quote exists
 * (enforced server-side in render.php), so no JS guard is needed.
 */

document.addEventListener( 'DOMContentLoaded', () => {
	const sliders = document.querySelectorAll( '[data-quotes-slider]' );

	if ( ! sliders.length ) {
		return;
	}

	/**
	 * Poll until window.EmblaCarousel is available, then invoke the callback.
	 *
	 * @param {Function} callback - Called once Embla is ready.
	 * @param {number}   attempts - Attempts made so far.
	 */
	const waitForEmbla = ( callback, attempts = 0 ) => {
		if ( typeof window.EmblaCarousel === 'function' ) {
			callback();
		} else if ( attempts < 30 ) {
			setTimeout( () => waitForEmbla( callback, attempts + 1 ), 100 );
		}
	};

	waitForEmbla( () => {
		sliders.forEach( viewport => {
			const block = viewport.closest( '.sol-quotes-slider' );

			if ( ! block ) {
				return;
			}

			const total      = parseInt( viewport.dataset.quotesSliderCount, 10 ) || 1;
			const prevBtn    = block.querySelector( '.sol-quotes-slider__prev' );
			const nextBtn    = block.querySelector( '.sol-quotes-slider__next' );
			const counterEl  = block.querySelector( '.sol-quotes-slider__counter-current' );

			const embla = window.EmblaCarousel( viewport, {
				loop:     false,
				dragFree: false,
			} );

			/**
			 * Update the "current / total" counter text.
			 */
			const updateCounter = () => {
				if ( ! counterEl ) {
					return;
				}
				counterEl.textContent = embla.selectedScrollSnap() + 1;
			};

			/**
			 * Disable prev/next buttons at the start and end of the track.
			 */
			const updateButtons = () => {
				if ( ! prevBtn || ! nextBtn ) {
					return;
				}
				prevBtn.disabled = ! embla.canScrollPrev();
				nextBtn.disabled = ! embla.canScrollNext();
			};

			if ( prevBtn ) {
				prevBtn.addEventListener( 'click', () => embla.scrollPrev() );
			}

			if ( nextBtn ) {
				nextBtn.addEventListener( 'click', () => embla.scrollNext() );
			}

			embla.on( 'init',   updateCounter );
			embla.on( 'select', updateCounter );
			embla.on( 'init',   updateButtons );
			embla.on( 'select', updateButtons );

			// Run immediately in case Embla fires init before the listener is attached.
			updateCounter();
			updateButtons();
		} );
	} );
} );
